import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';

const mapStyles = {
  width: '100%',
  height: '100%',
};

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '580px',
};

const GoogleMapComponent = () => {
  const [markers, setMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);

  useEffect(() => {
    const fetchCoordinates = async () => {
      try {
        const response = await fetch("https://rachpower-dad00-default-rtdb.firebaseio.com/psuDevices.json");
        if (response.ok) {
          const data = await response.json();
          const fetchedMarkers = Object.entries(data).map(([key, device]) => ({
            id: key,
            lat: parseFloat(device.latitude),
            lng: parseFloat(device.longitude),
            ...device
          }));
          setMarkers(fetchedMarkers);
        } else {
          console.error('Failed to fetch data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchCoordinates();
  }, []);

  return (
    <div className='p-6 bg-slate-50'>
      <div className='mb-6'>
        <h1 className='text-2xl font-bold text-gray-800'>Device Location Map</h1>
        <p className='text-sm text-gray-600 mt-1'>Interactive map showing the geographical distribution of all PSU devices</p>
      </div>
      <div style={containerStyle} className='bg-white rounded-xl shadow-md overflow-hidden'>
        <LoadScript googleMapsApiKey="">
          <GoogleMap
            mapContainerStyle={mapStyles}
            center={markers.length > 0 ? { lat: markers[1].lng, lng: markers[1].lat } : { lat: 0, lng: 0 }}
            zoom={4.3}
          >
            {markers.map(marker => (
              <Marker
                key={marker.id}
                position={{ lat: marker.lng, lng: marker.lat }}
                onClick={() => setSelectedMarker(marker)}
              />
            ))}
            {selectedMarker && (
              <InfoWindow
                position={{ lat: selectedMarker.lng, lng: selectedMarker.lat }}
                onCloseClick={() => setSelectedMarker(null)}
              >
                <div>
                  <h2>{selectedMarker.client}</h2>
                  <p><strong>Project:</strong> {selectedMarker.project}</p>
                  <p><strong>Site:</strong> {selectedMarker.site}</p>
                  <p><strong>City:</strong> {selectedMarker.city}</p>
                  <p><strong>Cluster:</strong> {selectedMarker.cluster}</p>
                  <p><strong>Zone:</strong> {selectedMarker.zone}</p>
                  <p><strong>Voltage Leak:</strong> {selectedMarker.leak_volt}</p>
                  <p><strong>Main Voltage:</strong> {selectedMarker.mains_volt}</p>
                  <p><strong>Temperature:</strong> {selectedMarker.temperature}</p>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
};

export default GoogleMapComponent;
